import script from "./Sizes.vue?vue&type=script&setup=true&lang=js"
export * from "./Sizes.vue?vue&type=script&setup=true&lang=js"

import "./Sizes.vue?vue&type=style&index=0&id=568baf63&lang=scss"

const __exports__ = script;

export default __exports__